import axios from 'axios';
import {
  useEffect, useState, useReducer, useMemo, useCallback,
} from 'react';
import { Routes, Route } from 'react-router-dom';
import { cartReducer, initalCartState, CartTypes } from './reducers/cartReducer';
import Header from './components/Header';
import Details from './components/Details';
import DetailItem from './components/DetailItem';
import Cart from './components/Cart';

import Home from './components/Home';
import NotFound from './components/NotFound';
import CurrentUserContext from './contexts/CurrentUserContext';
import Login from './components/Login';
import Orders from './components/Orders';

const storageKey = 'cart';

function App() {
  const [items, setItems] = useState([]);
  const [currentUser, setCurrentUser] = useState({});
  const [cart, dispatch] = useReducer(
    cartReducer,
    initalCartState,
    (initialState) => {
      try {
        const cartJson = JSON.parse(localStorage.getItem(storageKey));
        return cartJson || initialState;
      } catch (error) {
        console.log(error);
        return initialState;
      }
    },
  );
  const addToCart = useCallback((itemId) => {
    dispatch({ type: CartTypes.ADD, itemId });
  }, []);
  useEffect(() => {
    localStorage.setItem(storageKey, JSON.stringify(cart));
  }, [cart]);

  useEffect(() => {
    axios.get('/api/items').then((res) => {
      setItems(res.data);
    }).catch((err) => {
      console.log(err);
    });
  }, []);

  useEffect(() => {
    axios.get('/api/auth/current-user').then((res) => {
      setCurrentUser(res.data);
    }).catch((err) => {
      console.log(err);
    });
  }, []);

  const currentUserContextValue = useMemo(() => ({ currentUser, setCurrentUser }), [currentUser]);

  return (
    <div>
      <CurrentUserContext.Provider value={currentUserContextValue}>
        <Header cart={cart} />
        {items.length === 0 ? (
          <div>Loading...</div>
        ) : (
          <Routes>
            <Route
              path="/cart"
              element={<Cart cart={cart} items={items} dispatch={dispatch} />}
            />
            <Route path="/details" element={<Details items={items} />}>
              <Route
                path=":id"
                element={<DetailItem items={items} addToCart={addToCart} />}
              />
              <Route index element={<div>No Item Selected</div>} />
            </Route>
            <Route path="/" element={<Home items={items} />} />
            <Route path="/login" element={<Login />} />
            <Route path="/orders" element={<Orders items={items} />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        )}
      </CurrentUserContext.Provider>
    </div>
  );
}

export default App;
